'use strict';

import { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import DishImage from './DishImage.react';
import './EditMealServingsModalPrimary.scss';

export default class LeftoverDishesSection extends Component {
    static propTypes = {
        dishes: PropTypes.array.isRequired,
        contents: PropTypes.object.isRequired,
        plan: PropTypes.object,
        allMeals: PropTypes.array,
        onNavigateToOriginalMeal: PropTypes.func,
    };

    static defaultProps = {
        plan: null,
        allMeals: [],
        onNavigateToOriginalMeal: null,
    };

    static contextTypes = {
        meals: PropTypes.array,
    };

    render() {
        const { dishes, contents, plan, allMeals, onNavigateToOriginalMeal } = this.props;
        const { meals: contextMeals } = this.context;

        // Group leftover dishes by parent meal
        const leftoversByParent = {};

        dishes.forEach(dish => {
            if (dish.isLeftover) {
                const parentId = dish.main.parent_uuid || dish.main.parent;
                if (!leftoversByParent[parentId]) {
                    leftoversByParent[parentId] = [];
                }
                leftoversByParent[parentId].push(dish);
            }
        });

        return (
            <div className="leftover-dishes-container">
                {/* Render leftover dishes grouped by parent */}
                {Object.entries(leftoversByParent).map(([parentId, leftoverDishes]) => {
                    // Find parent meal info - use the correct source based on context
                    // For Plans/Editor (PRO): plan.items contains all meals, contextMeals is limited to slot
                    // For consumer: contextMeals contains all meals, allMeals is filtered subset
                    const allAvailableMeals = plan ? plan.items : (contextMeals || allMeals);
                    const parentMeal = allAvailableMeals.find(m =>
                        (plan ? m.id === parentId : m.uuid === parentId)
                    );

                    let parentDate = 'Unknown Date';
                    if (parentMeal) {
                        if (parentMeal.offset !== undefined) {
                            // PRO side: has offset (integer) - use Day X format
                            parentDate = `Day ${parentMeal.offset + 1}`;
                        } else if (parentMeal.date) {
                            // Consumer side: has date string
                            parentDate = moment(parentMeal.date).format('dddd, MMM D');
                        }
                    }

                    return leftoverDishes.map((dish, index) => {
                        const content = contents[dish.main.recipe_uuid || dish.main.food_uuid];
                        const imageUrl = content?.image;
                        const title = content?.title || content?.name || 'Unknown Dish';

                        return (
                            <div key={`leftover-${parentId}-${index}`} className="meal-item leftover-dish">
                                <DishImage imageUrl={imageUrl} title={title} />
                                {/* <div className="leftover-badge">LEFTOVER</div> */}
                                <div className="meal-item-details">
                                    <div className="meal-item-name">{title}</div>
                                    <div className="leftover-parent-info">
                                        {/* Only show "edit original meal" link on consumer side (not PRO/plan editor) */}
                                        {!plan && onNavigateToOriginalMeal && (
                                            <button
                                                className="edit-original-meal-link"
                                                onClick={() => onNavigateToOriginalMeal(parentId, dish.main)}
                                            >
                                                edit original meal
                                            </button>
                                        )}
                                        <span className="leftover-date">{!plan ? ', ' : ''}{parentDate}</span>
                                    </div>
                                </div>
                            </div>
                        );
                    });
                })}
            </div>
        );
    }
}
